import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase URL ou Anon Key não encontrados. Verifique as variáveis de ambiente.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface BlogPost {
  id: string;
  company_id: string;
  platform: string;
  status: string;
  copy_text: string;
  copy_hook: string;
  copy_cta: string;
  hashtags: string[] | null;
  image_url: string | null;
  published_at: string;
  slug?: string | null;
}

const COMPANY_ID = '571256a3-db03-4483-b7dd-cf3735c54916';

export const blogService = {
  async getLatestPosts(limit = 3) {
    const { data, error } = await supabase
      .from('posts')
      .select('*')
      .eq('company_id', COMPANY_ID)
      .eq('platform', 'native_blog')
      .eq('status', 'published')
      .order('published_at', { ascending: false })
      .limit(limit);

    if (error) throw error;
    return data as BlogPost[];
  },

  async getAllPosts() {
    const { data, error } = await supabase
      .from('posts')
      .select('*')
      .eq('company_id', COMPANY_ID)
      .eq('platform', 'native_blog')
      .eq('status', 'published')
      .order('published_at', { ascending: false });

    if (error) throw error;
    return data as BlogPost[];
  },

  async getPostById(slugOrId: string) {
    // Tenta buscar por slug primeiro
    let queryResult = await supabase
      .from('posts')
      .select('*')
      .eq('company_id', COMPANY_ID)
      .eq('platform', 'native_blog')
      .eq('status', 'published')
      .eq('slug', slugOrId)
      .maybeSingle();

    // Se falhou por slug, tenta buscar assumindo que o param era um UUID
    if (!queryResult.data && slugOrId.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i)) {
      queryResult = await supabase
        .from('posts')
        .select('*')
        .eq('company_id', COMPANY_ID)
        .eq('platform', 'native_blog')
        .eq('status', 'published')
        .eq('id', slugOrId)
        .maybeSingle();
    }

    if (queryResult.error) throw queryResult.error;
    return queryResult.data as BlogPost;
  }
};
